<template>
<div class="mdc-dialog">
    <div class="mdc-dialog__container">
        <dialog-surface
            :options="options"
            @close="$emit('close')"
            @click="$emit('click', $event)">
            <slot></slot>
            <template
                v-if="$slots.bottom"
                #bottom>
                <slot name="bottom"></slot>
            </template>
        </dialog-surface>
    </div>
    <div class="mdc-dialog__scrim"></div>
</div>
</template>

<script>
import { MDCDialog, strings } from "@material/dialog";
import DialogSurface from "./DialogSurface.vue";
export default {
    components: { DialogSurface },
    props: {
        options: { type: Object, default: () => ({}) }
    },
    data: () => ({ instance: null }),
    mounted() {
        const dialog = new MDCDialog(this.$el);
        dialog.autoStackButtons = false;
        dialog.listen(strings.CLOSED_EVENT, ({ detail: { action } }) =>
            this.$emit("close", action));
        if (!this.options.dismissible) {
            dialog.escapeKeyAction = "";
            dialog.scrimClickAction = "";
        }
        dialog.open();
        this.instance = dialog;
    },
    updated() {
        if (this.instance) this.instance.layout();
    }
};
</script>
